import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
/**
 * @summary BaseSearchOrgFilters
 * @extends {mapStatePropertiesMixin(AoflElement)}
 */
@customElement('base-search-org-filters')
class BaseSearchOrgFilters extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of BaseSearchOrgFilters.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'base-search-org-filters';
  @property({type: Number})
  ['max-level'] = 0;

  @property({type: Boolean})
  ['show-reset'] = false;

  @property({type: Number, attribute: false})
  groupId = 0;

  @property({type: Array, attribute: false})
  selectedGroups = [];
  /**
   *
   * @protected
   * @param {CustomEvent} e
   */
  filterUpdated(e) {}

  mapStateProperties() {
    const state = this.storeInstance.getState();

    this.groupId = state[sdoNs.SESSION].group_info.id;
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export {
  BaseSearchOrgFilters
};
